import script from "./lightbox.vue?vue&type=script&setup=true&lang=js"
export * from "./lightbox.vue?vue&type=script&setup=true&lang=js"

import "./lightbox.vue?vue&type=style&index=0&id=2104af78&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2104af78"]])

export default __exports__